export function FormataData(data: string) {
    return new Date(data).toLocaleDateString("pt-BR")

}